<template>
    <div class="dynamic-content">
        <h1 class="page-title">SmartRewards Rules</h1>

        <div class="content-section intro-section">
            <p class="desc-text">SmartRewards Rules (Explanatory Guidelines)</p>
            <p class="desc-text">This document explains how the SmartRewards program operates</p>
            <p class="desc-text">for informational purposes only.</p>
            <p class="desc-text">It does not replace, modify, or override</p>
            <p class="desc-text">the SmartRewards Program - Terms & Conditions.</p>
            <p class="desc-text">All participation, eligibility, and rewards</p>
            <p class="desc-text">are governed solely by the SmartRewards Program - Terms & Conditions.</p>
        </div>

        <div class="content-section compact-section">
            <h2 class="section-title">1. Effective Platform Benefits</h2>
            <p class="desc-text">Effective Platform Benefits reflect a participant's accumulated engagement,</p>
            <p class="desc-text">activity, and participation history on the XigFor platform.</p>
            <p class="desc-text">These benefits are derived from ongoing platform participation,</p>
            <p class="desc-text">including but not limited to listings, completed transactions,</p>
            <p class="desc-text">buyer engagement, and eligible platform activities.</p>
            <p class="desc-text">Participation indicators and visual progress displays</p>
            <p class="desc-text">represent engagement progression only,</p>
            <p class="desc-text">not financial outcomes or guaranteed performance.</p>
        </div>

        <div class="content-section compact-section">
            <h2 class="section-title">2. Platform Benefit Credits</h2>
            <p class="desc-text">Platform Benefit Credits are promotional credits</p>
            <p class="desc-text">issued at the platform's discretion</p>
            <p class="desc-text">based on participation and eligibility criteria.</p>
            <p class="desc-text">Applying Platform Benefit Credits is considered</p>
            <p class="desc-text">a service fee offset mechanism,</p>
            <p class="desc-text">not a reduction of the underlying platform service fee rate.</p>
            <p class="desc-text">The payable service fee remains applicable</p>
            <p class="desc-text">and is satisfied in whole or in part</p>
            <p class="desc-text">through eligible Platform Benefit Credits.</p>
            <p class="desc-text">The platform's standard service fee structure</p>
            <p class="desc-text">remains unchanged at all times.</p>
            <p class="desc-text">Platform Benefit Credits:</p>
            <p class="desc-text">Are not cash or cash equivalents</p>
            <p class="desc-text">Are not stored value</p>
            <p class="desc-text">Are not withdrawable</p>
            <p class="desc-text">Are not transferable outside the platform</p>
            <p class="desc-text">Credits may only be used within the XigFor platform</p>
            <p class="desc-text">for eligible goods, services, promotional placements,</p>
            <p class="desc-text">or platform features as specified from time to time.</p>
        </div>

        <div class="content-section compact-section">
            <h2 class="section-title">3. Fees & Service Models</h2>
            <p class="desc-text">XigFor operates multiple transparent service fee models,</p>
            <p class="desc-text">which may include:</p>
            <p class="desc-text">Standard platform service fees</p>
            <p class="desc-text">Fixed minimum service fees for low-value transactions</p>
            <p class="desc-text">Participation-based service models tied to the Growth Program</p>
            <p class="desc-text">Eligibility-based application of Platform Benefit Credits</p>
            <p class="desc-text">to offset applicable platform service fees</p>
            <p class="desc-text">The availability of any service model</p>
            <p class="desc-text">does not alter the platform's underlying service fee structure</p>
            <p class="desc-text">and does not create an entitlement to fee-free usage.</p>
        </div>

        <div class="content-section compact-section">
            <h2 class="section-title">4. Rewards & Limitations</h2>
            <p class="desc-text">All rewards and credits issued under the Growth Program</p>
            <p class="desc-text">are promotional in nature.</p>
            <p class="desc-text">They:</p>
            <p class="desc-text">Are not investments</p>
            <p class="desc-text">Do not represent income</p>
            <p class="desc-text">Do not guarantee earnings or returns</p>
            <p class="desc-text">May expire, be adjusted, suspended, or revoked</p>
            <p class="desc-text">XigFor reserves the right to restrict or revoke rewards</p>
            <p class="desc-text">in cases including but not limited to fraud, abuse,</p>
            <p class="desc-text">policy violations, or system misuse.</p>
        </div>

        <div class="content-section compact-section">
            <h2 class="section-title">5. Participation Control</h2>
            <p class="desc-text">Participation in the Growth Program is optional.</p>
            <p class="desc-text">Sellers may choose whether to participate</p>
            <p class="desc-text">and may modify or discontinue participation</p>
            <p class="desc-text">for future listings at any time.</p>
            <p class="desc-text">Opting out does not affect prior completed transactions</p>
            <p class="desc-text">or previously applied credits.</p>
        </div>

        <div class="content-section compact-section">
            <h2 class="section-title">6. Risk Management & Adjustments</h2>
            <p class="desc-text">XigFor may adjust participation thresholds,</p>
            <p class="desc-text">eligibility criteria, or reward availability</p>
            <p class="desc-text">to ensure platform stability,</p>
            <p class="desc-text">fraud prevention, and regulatory compliance.</p>
        </div>

        <div class="content-section compact-section">
            <h2 class="section-title">7. No Guarantee Clause</h2>
            <p class="desc-text">Participation in the Growth Program</p>
            <p class="desc-text">does not create any expectation of profit,</p>
            <p class="desc-text">financial return, or continued availability of benefits.</p>
            <p class="desc-text">All participation metrics and progress indicators</p>
            <p class="desc-text">are illustrative only.</p>
        </div>

        <div class="content-section compact-section">
            <h2 class="section-title">8. Regulatory Positioning</h2>
            <p class="desc-text">The XigFor Growth Program is a promotional participation program.</p>
            <p class="desc-text">It does not constitute:</p>
            <p class="desc-text">An investment contract</p>
            <p class="desc-text">A revenue-sharing arrangement</p>
            <p class="desc-text">A financial product</p>
            <p class="desc-text">A commission or savings program</p>
            <p class="desc-text">Platform Benefit Credits are issued solely</p>
            <p class="desc-text">to encourage platform participation and engagement.</p>
        </div>

        <div class="content-section compact-section">
            <h2 class="section-title">9. Amendments</h2>
            <p class="desc-text">XigFor may update these Rules</p>
            <p class="desc-text">based on platform development, policy updates,</p>
            <p class="desc-text">or regulatory requirements.</p>
            <p class="desc-text">Continued participation after updates</p>
            <p class="desc-text">constitutes acceptance of the revised terms.</p>
            <p class="desc-text">For full legal terms, dispute resolution, and contact information,</p>
            <p class="desc-text">please refer to the SmartRewards Program - Terms & Conditions.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SmartRewardsRules'
}
</script>

<style scoped>
@import '../info/shared-info-styles.css';

.dynamic-content {
    /* max-width: 760px; */
}

.page-title {
    margin-bottom: 14px;
    font-size: 40px;
    font-weight: 700;
    color: #393944;
}

.intro-section {
    margin-bottom: 16px;
}

.compact-section {
    margin-bottom: 18px;
}

.section-title {
    font-family: 'Poppins Light', sans-serif;
    font-size: 26px;
    font-weight: 300;
    line-height: 56px;
    color: #6C6C78;
    margin-top: 0;
    margin-bottom: 8px;
}

.desc-text {
    font-family: 'Poppins Light', sans-serif;
    font-size: 26px;
    font-weight: 300;
    line-height: 56px;
    color: #6C6C78;
    margin-bottom: 2px;
}

@media (max-width: 900px) {
    .page-title {
        font-size: 20px;
        font-weight: 700;
        color: #393944;
        margin-bottom: 10px;
        line-height: 1.3;
    }

    .section-title {
        font-family: 'Poppins Light', sans-serif;
        font-size: 10px;
        font-weight: 300;
        line-height: 20px;
        color: #6C6C78;
        margin-bottom: 5px;
    }

    .desc-text {
        font-family: 'Poppins Light', sans-serif;
        font-size: 10px;
        font-weight: 300;
        line-height: 20px;
        color: #6C6C78;
        margin-bottom: 2px;
    }

    .compact-section {
        margin-bottom: 14px;
    }

    .intro-section {
        margin-bottom: 12px;
    }
}
</style>
